import { render, staticRenderFns } from "./seaTurtles2.vue?vue&type=template&id=47ef8c36"
import script from "./seaTurtles2.vue?vue&type=script&lang=js"
export * from "./seaTurtles2.vue?vue&type=script&lang=js"
import style0 from "./seaTurtles2.vue?vue&type=style&index=0&id=47ef8c36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports